import http from './http-common'

// Contratos do backoffice (estetica-api: /admin/stats/* e /admin/activity/*)

export type KpiValue = { value: number; deltaPercent: number | null }

export type AdminOverview = {
    activeUsers: KpiValue
    newPlans: KpiValue
    revenue: KpiValue
    catalogItems: { value: number; deltaCount: number }
}

export type SignupWeek = { weekStart: string; count: number }

export type RecentActivity = {
    id: number | string
    type: string
    title: string
    description: string
    actorName: string
    tag: string
    at: string
}

export type PendingItem = {
    id: number | string
    label: string
    actionLabel: string
    actionPath: string
    tone: string
}

export type NotRenewedUser = {
    name: string
    email: string
    phone: string | null
    plan: string | null
    expiredAt: string
}

export const getAdminOverview = (period = '30d') =>
    http.get<AdminOverview>(`/admin/stats/overview?period=${period}`)

export const getAdminUsersNotRenewed = () =>
    http.get<NotRenewedUser[]>(`/admin/users/not-renewed`)

export const getAdminSignups = (period = '30d') =>
    http.get<SignupWeek[]>(`/admin/stats/signups?period=${period}`)

export const getAdminRecentActivity = (limit = 8) =>
    http.get<RecentActivity[]>(`/admin/activity/recent?limit=${limit}`)

export const getAdminPending = () => http.get<PendingItem[]>(`/admin/activity/pending`)
